import create from "zustand";

import { storageSession } from "../utils/StorageHandler";

export type TrackingState = {
    app: {
        parameter?: string;
    };
};

export type TrackingActions = {
    setAppParameter: (appParameter: string) => void;
    resetAppParameter: () => void;
};

export type TrackingStore = TrackingState & TrackingActions;

const initialState: TrackingState = {
    app: {
        parameter: undefined,
    },
};

export const useTracking = create<TrackingStore>((set, get) => {
    const rawAppParameter =
        storageSession.getString("app:parameter") ?? undefined;

    return {
        ...initialState,
        app: {
            parameter: ["none", undefined].includes(rawAppParameter)
                ? initialState.app.parameter
                : rawAppParameter,
        },

        setAppParameter: (parameter) => {
            storageSession.setString("app:parameter", parameter);
            set(({ app }) => ({
                app: {
                    ...app,
                    parameter,
                },
            }));
        },
        resetAppParameter: () => {
            storageSession.remove("app:parameter");
            set(({ app }) => ({
                app: {
                    ...app,
                    parameter: initialState.app.parameter,
                },
            }));
        },
    };
});
